"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SIZES=void 0;var SIZES={XS:"xs",MD:"md",SM:"sm"};exports.SIZES=SIZES;